
export default [
  {
    path: "/guide",
    name: "guide",
    component: () => import('@/views/guide/Guide.vue'),
  },
];
